import React from 'react';
import PropTypes from 'prop-types';
import styles from './SbSharedRefineMenuSearchInput.scss';
import classnames from 'classnames';
import SearchIcon from 'dibs-vg/dist/react/magnifying-glass';

export function SbSharedRefineMenuSearchInput(props) {
    const { className, onSubmit, value, onInput, placeholder } = props;
    const containerClass = classnames(styles.container, className);
    return (
        <div className={containerClass}>
            <form className={styles.form} onSubmit={onSubmit} action="">
                <input
                    defaultValue={value}
                    onInput={onInput}
                    type="search"
                    placeholder={placeholder}
                    className={styles.input}
                    autoCorrect="off"
                    autoCapitalize="off"
                    autoComplete={props.autoComplete}
                    spellCheck="false"
                    data-tn="search-input"
                />
            </form>
            <div className={styles.searchIconWrapper} onClick={onSubmit}>
                <SearchIcon className={styles.searchIcon} />
            </div>
        </div>
    );
}

SbSharedRefineMenuSearchInput.defaultProps = {
    autoComplete: 'off',
};

SbSharedRefineMenuSearchInput.propTypes = {
    onInput: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    placeholder: PropTypes.string.isRequired,
    className: PropTypes.string,
    autoComplete: PropTypes.string,
    value: PropTypes.string.isRequired,
};
